<template>
  <div :style="clusterStyle">
    <div class="box-head">3D structure rendered by clusters</div>

    <div class="box-tool">
      <a :href="$store.state.host+`/dokhlab/actions/ohm/result?id=${task.id}&file=cluster-pse`">{{task.id}}-cluster.pse</a>
    </div>

    <div v-if="!showStructure">
      <el-button type="text" @click.native="viewClusters">View Clusters</el-button>
    </div>

    <!--
    <div v-if="showStructure && !structureReady">
      Loading (This may take a few minutes) <i class="el-icon-loading"></i>
    </div>
    -->

    <div v-show="showStructure" v-loading="showStructure && !structureReady">
      <ngl-view class="ngl-view" ref="ngl" :height="600" :nameWidth="200"></ngl-view>
    </div>
  </div>
</template>

<script>
// import interpolate from 'color-interpolate'
import * as NGL from 'ngl'
import { saveAs } from 'file-saver'
import NglView from './NglView/NglView.vue'
// import * as NGL from 'ngl'
import axios from 'axios'

export default {
  name: 'Cluster',

  data () {
    return {
      active_site: [],
      allosteric_site: [],
      clusterStyle: {
        width: '100%',
//        border: '1px solid #eeeeee',
        margin: '20px 0px',
        position: 'relative',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-khtml-user-select': 'none',
        '-ms-user-select': 'none'
      },
      paths: {},
      showStructure: false,
      structureReady: false
    }
  },

  props: [ 'value' ],

  components: {
    NglView
  },

  computed: {
    task () {
      return this.$store.state.task
    }
  },

  methods: {
    download () {
      this.cyPromise.then(cy => {
        saveAs(cy.png({'output': 'blob'}), 'nodes.png')
      })
    },

    redirect (url) {
      window.location.href = url
    },

    openNewTab (url) {
      window.open(url, '_blank')
    },

//    getIndByNum (num) {
//      return this.task.results.ind.find(i => i.num === num)
//    },

    getInd (chainName, resNum) {
      return this.task.results.ind.find(i => i.name === `${chainName}/${resNum}`)
    },

    getSites (sites) {
      let vec = []
      let ls = sites.trim().split(/,/)
      for (let s of ls) {
        let w = s.split(/\//)
        let chainName = w[0]
        let residues = w[1]
        let v = residues.split(/\+/)
        for (let i of v) {
          let u = i.split(/-/)
          if (u.length === 2) {
            let a = parseInt(u[0])
            let b = parseInt(u[1])
            for (let j = a; j <= b; j++) {
              vec.push(this.getInd(chainName, j).num)
            }
          } else if (u.length === 1) {
            vec.push(this.getInd(chainName, u[0]).num)
          }
        }
      }
      return vec
    },

    setSites () {
      let v = this
      v.active_site = v.getSites(v.task.par.active_site)
    },

    viewClusters () {
      this.showStructure = true
      this.$nextTick(() => {
        this.checkTask()
      })
    },

    checkTask () {
      let v = this
      let task = this.task

      if (task) {
        v.$refs.ngl.load(new Blob([v.task.par.structure_data], {type: 'text/plain'}), { ext: v.task.par.structure_type }).then(obj => {
          obj.setColor('bfactor')

          let url = v.$store.state.host + `/dokhlab/actions/ohm/result?id=${task.id}&file=clusters`

          axios({
            method: 'get',
            url,
            withCredentials: true,
            transformResponse: []
          }).then(response => {
            console.log(response.data)
            response.data.split('\n').filter(l => l.trim()).forEach((line, i) => {
              let ls = line.trim().split(':')
              let ls1 = ls[0].trim().split(/\s+/)
              let ls2 = ls[1].trim().split(/\s+/)
              let color = ls1[2]
              let selections = ls2.map(i => {
                let l = i.split('-')
                return `${l[1]}:${l[0]}`
              }).join(' or ')
              let sel = v.$refs.ngl.store.makeObject(`clust${i + 1}`, 'selection', [obj.components[0]], [new NGL.Selection(selections)])
              v.$refs.ngl.store.objects.push(sel)
              sel.setColor(color)

              v.structureReady = true
            })
          }).catch(error => {
            console.log(error)
          })
        })
      } else {
        setTimeout(() => {
          v.checkTask()
        }, 500)
      }
    }
  },

  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.ngl-view {
/*
  border: 1px solid #eeeeee;
  margin: 20px 0px;
  */
}

.box-head {
  padding: 10px;
  border-bottom: 1px solid #eeeeee;
  background-color: $theme-color;
  font-weight: 700;
  color: white;
}

.box-tool {
  padding:10px 0px;
  /*
  border-bottom:1px solid #eeeeee
  */
}

</style>
